import { Box, Container, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(2, 3, 0, 3),
  },
  input: {
    margin: theme.spacing(2, 0),
  },
  containerButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    margin: theme.spacing(0, 4, 0, 0),
  },
}));
function SkeletonFinalProject() {
  const classes = useStyles();
  return (
    <Box>
      <Skeleton variant="rect" width={120} height={40} />
      <Box className={classes.container}>
        <Skeleton variant="text" width={200} height={50} />
        <Skeleton variant="rect" width={1200} height={190} />
        <Skeleton className={classes.input} variant="rect" width={1200} height={50} />
        <Container className={classes.containerButton}>
          <Skeleton variant="rect" width={120} height={40} />
        </Container>
      </Box>
    </Box>
  );
}

export default SkeletonFinalProject;
